export enum ServiceGroupsType {
  Unassigned = "Unassigned",
  Assigned = "Assigned",
  Started = "Started",
  Aborted = "Aborted",
  Canceled = "Canceled",
  Completed = "Completed",
  ManualCompleted = "ManualCompleted",
  Risk = "Risk"
}
